import { render, staticRenderFns } from "./ModalAppointment.vue?vue&type=template&id=36cf2a80&scoped=true"
import script from "./ModalAppointment.vue?vue&type=script&lang=js"
export * from "./ModalAppointment.vue?vue&type=script&lang=js"
import style0 from "./ModalAppointment.vue?vue&type=style&index=0&id=36cf2a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf2a80",
  null
  
)

export default component.exports